export enum LightModernBadgeVariantType {
  Pastel = 'pastel',
  AccentText = 'accent-text',
  JuicyWarm = 'juicy-warm',
}
